import { api } from './client.js';

const root = '/admin/tasks';

export const tasksApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  remove: (id) => api.delete(`${root}/${id}`)
};
